import { observable, action, computed } from "mobx"
import { Step, BookingFlow } from "../../BookingFlow"
import { BookingDB } from "../../db/BookingLightDB"
import { DayPickerFormComp } from "./DayPickerFormComp"
import React from "react"
import dayjs = require("dayjs")
import { Modal } from "BookingSystem/utils/Modal"

export class DayPickerStep implements Step {
  @observable
  flow: BookingFlow

  @observable
  db: BookingDB

  @observable
  name = "daypicker"

  @observable
  help = "Visiting today? Click next"

  @observable
  instruction = "When will you be visiting Lava Island?"

  @computed
  get displayDate() {
    if (
      this.flow.currentBooking.arrivingDate.format("MM-DD-YYYY") ===
      dayjs().format("MM-DD-YYYY")
    ) {
      return "Today"
    } else
      return this.flow.currentBooking.arrivingDate.format("ddd MMM DD, YYYY")
  }

  @action.bound
  setDateAttending(date: Date) {
    this.flow.currentBooking.object.arrivingDateString = dayjs(
      date
    ).toISOString()
  }

  showDatePickerModal() {
    const modal = new Modal(this.flow)
    modal.title = "Pick a date below."
    modal.primaryButtonText = "Done"
    modal.primaryDisabled = false
    modal.children = React.createElement(DayPickerFormComp, {
      model: this
    })
    this.flow.showModal(() => modal)
  }
}
